<template>
  <div>
    <b-input-group content-cols="1">
      <b-form-input
        id="input-customer"
        style="width: 120px"
        size="sm"
        type="text"
        readonly
        :placeholder="$t('message.tasks.modal.customerPlaceholder')"
        v-model="selectedTitle"
      />
      <b-input-group-append>
        <b-btn size="sm" variant="outline-success" @click.stop="showModal">Выбрать</b-btn>
        <b-btn size="sm" variant="secondary" @click.stop="onClearSelected"><font-awesome-icon icon="times-circle"/></b-btn>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      id="location-multi-select-modal"
      ref="location_multi_select_modal"
      body-class="modal-body-select"
      title="Объекты"
      size="xl"
      @close="onCancel"
      scrollable
    >
      <b-navbar id="modal-filters">
        <b-navbar-nav>
          <b-input-group>
            <b-form-input
              id="input-location"
              size="sm"
              v-model="query"
              placeholder="Поиск объекта"
              autocomplete="off"
            />
            <b-input-group-append>
              <b-button size="sm" @click.stop="onClearQuery">
                <font-awesome-icon icon="times-circle"/>
              </b-button>
            </b-input-group-append>
          </b-input-group>

          <b-form-select
            id="input-payment-type"
            class="mb-0 ml-2"
            size="sm"
            v-model="paymentType"
            @change="onChangePaymentType"
          >
            <option :value="-1">Все типы оплаты</option>
            <option v-for="option in paymentTypes" :value="option.value">
              {{ option.text }}
            </option>
          </b-form-select>

          <b-button
            v-if="showDateButton"
            size="sm"
            :variant="isShowDateButtonActive?  'success' : 'info'"
            class="mb-0 ml-2 d-flex align-items-center justify-content-center"
            @click="toggleDateFilter"
          >
            <font-awesome-icon :icon="['fas', isShowDateButtonActive ? 'calendar-check' : 'calendar-minus']"/>
            <span id="location-date-search" class="ml-2">
              {{isShowDateButtonActive ? 'Поиск по выбранным датам' : 'Поиск по всем датам'}}
            </span>
          </b-button>
        </b-navbar-nav>
      </b-navbar>

      <b-table
        id="modal-locations"
        ref="locations"
        class="mb-0 text-small modal-sticky"
        striped
        small
        hover
        responsive
        show-empty
        :empty-text="$t('message.common.emptyTable')"
        :busy.sync="isBusy"
        :items="items"
        :fields="fields"
        @row-clicked="rowClicked"
        :tbody-tr-class="tbodyRowClass"
        no-provider-filtering
        no-provider-paging
        no-provider-sorting
        sticky-header
        head-variant="light"
      />

      <pagination-footer
        :total-rows="totalRows"
        :per-page.sync="perPage"
        @page-click="onPagination"
        @per-page-change="onPerPageChange"
      />

      <template #modal-footer>
        <div class="w-100">
          <p class="float-left">Выбраны: {{ tempSelected.length }}</p>
          <b-button
            variant="primary"
            size="sm"
            class="mr-1 float-right"
            @click="onOk"
          >
            Применить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";

export default {
  name: "LocationMultiSelect",
  components: { PaginationFooter },
  mixins: [
    locations,
    pageSearchService
  ],
  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    showDateButton: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [],
      selected: [],
      tempSelected: [],
      isBusy: false,
      fields: [
        {
          key: 'id',
          class: 'location-multi-select-id'
        },
        {
          key: 'name',
          label: 'Название'
        },
        {
          key: 'customer_name',
          label: 'Заказчик'
        }
      ],
      query: '',
      paymentType: -1,
      paymentTypes: [
        { text: 'Нал', value: 0 },
        { text: 'ООО', value: 1 },
        { text: 'ИП', value: 2 },
      ],
      isShowDateButtonActive: true,
    }
  },
  computed: {
    selectedTitle() {
      if (this.selected.length === 0) {
        return `Все объекты`;
      }
      return `Объекты ${this.selected.length}`;
    },
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query) {
          await this.getItems();
        }
      }, deep: true
    },
  },
  methods: {
    async configure(locationIds) {
      let locations = [];

      for (const index in locationIds) {
        const id = parseInt(locationIds[index]);
        const location = (await this.getLocationById(id)).data;
        if (location != null) {
          locations.push(location);
        }
      }

      this.selected = locations;
    },
    async showModal() {
      this.tempSelected = [...this.selected];
      this.$refs.location_multi_select_modal.show();
      await this.getItems();
    },
    onClearSelected() {
      this.selected = [];
      this.$emit('onSelect', this.selected);
    },
    onClearQuery() {
      this.query = '';
    },
    onOk() {
      this.selected = [...this.tempSelected];
      this.$emit('onSelect', this.selected);
      this.$refs.location_multi_select_modal.hide();
    },
    onCancel() {
      this.tempSelected = [];
      this.query = '';
    },
    rowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.tempSelected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.tempSelected.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.tempSelected.push(item);
        this.$set(item, 'selected', true);
      }
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query.toLowerCase(),
        payment_type_int: this.paymentType,
        start_date: this.startDate,
        end_date: this.endDate,
      };

      let result;

      if (this.showDateButton && this.isShowDateButtonActive) {
        result = await this.getLocationsSearchByDate(data);
      } else {
        result = await this.getLocationsSearch(data);
      }

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      this.totalRows = result.data.total;
      this.items = result.data.items;
      this.updateSelected();
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach((item) => {
        const isSelected = this.tempSelected.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
    async onChangePaymentType() {
      this.currentPage = 1;
      await this.getItems()
    },
    async toggleDateFilter() {
      this.isShowDateButtonActive = !this.isShowDateButtonActive;
      await this.getItems();
    }
  },
}
</script>

<style>
.location-multi-select-id {
  padding-left: 10px !important;
}

#location-date-search {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationMultiSelect.vue